
const IntroSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-medium mb-6">Heaolu, tasakaal ja isiklik areng</h2>
          <p className="text-gray-700 mb-8">
            Toetan sind teekonnal vabanemaks piiravatest mõttemustritest, tuues teadlikkust trauma mõjust ja ennast juhtides luua võimaluse kujundada selline elu, mida igatsed. Pakun turvalist ja hinnangutevaba keskkonda, kus saad ennast sügavamalt tundma õppida just endale sobivas tempos. Läbi somaatilise kogemise oma keha ja meele koostööd parendada ning isiklikult kasvada.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
